import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';
import { useGuestsContext } from 'hb-react/shared/apps/Events/contexts/GuestsContext';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';
import {
  useGuestOptions,
  useGuestUpdate,
} from 'hb-react/shared/apps/Events/hooks';
import { getTicketInformation } from 'hb-react/shared/apps/Events/utils/getTicketInformation';

import AdditionalItemsForm from './components/AdditionalItemsForm';
import GuestsTicketForm from './components/GuestTicketForm';
import TicketForm from './components/TicketForm';

const EventTickets = ({ currentUser, attendeesAttributes }) => {
  const { event } = useEventContext();
  const { guests, actions } = useGuestsContext();

  const guestsOptions = useGuestOptions({ guests, currentUser });

  useGuestUpdate({
    guests,
    attendeesAttributes,
  });

  return attendeesAttributes.map((attendee, index) => {
    const ticket = getTicketInformation(event, attendee.ticket_id);

    return (
      <GuestsTicketForm
        attendee={attendee}
        currentUser={currentUser}
        guestsOptions={guestsOptions}
        ticket={ticket}
        index={index}
        key={`${index}-${attendee.ticket_id}`} // Using index plus object id to assure uniqueness
        updateGuest={actions.update}
        createGuest={actions.create}
        deleteGuest={actions.delete}
      />
    );
  });
};

const EventTicketsPo = ({ attendeesAttributes }) => {
  const { event } = useEventContext();

  return attendeesAttributes.map((attendee, index) => {
    const ticket = getTicketInformation(event, attendee.ticket_id);

    return (
      <TicketForm
        attendee={attendee}
        event={event}
        ticket={ticket}
        index={index}
        key={`${index}-${attendee.ticket_id}`} // Using index plus object id to assure uniqueness
      />
    );
  });
};

const EventRegistrationForm = ({ type }) => {
  const { values } = useFormikContext();

  const { currentUser } = useDefaultAppContexts();

  const { setValuesStep2 } = useRegistrationFlowContext();

  useEffect(() => {
    setValuesStep2(values);
  }, [values]);

  switch (type) {
    case 'tickets':
      return currentUser ? (
        <EventTickets
          currentUser={currentUser}
          attendeesAttributes={
            values.network_events_booking.attendees_attributes
          }
        />
      ) : (
        <EventTicketsPo
          attendeesAttributes={
            values.network_events_booking.attendees_attributes
          }
        />
      );
    case 'addons':
      return (
        <AdditionalItemsForm
          addons={values.network_events_booking.addons_attributes}
        />
      );
    default:
      return null;
  }
};

EventRegistrationForm.propTypes = {
  type: PropTypes.string,
};

EventRegistrationForm.defaultProps = {
  type: 'tickets',
};

export default EventRegistrationForm;
